export const getDisplayInformation = () => ({
  windowInnerHeight: window.innerHeight,
  windowInnerWidth: window.innerWidth,
  screenAvailHeight: window.screen.availHeight,
  screenAvailWidth: window.screen.availWidth,
  screenHeight: window.screen.height,
  screenWidth: window.screen.width,
  clientWidth: document.documentElement.clientWidth,
  clientHeight: document.documentElement.clientHeight,
  devicePixelRatio: window.devicePixelRatio,
});
